import * as React from "react"
import { Link } from "react-router-dom"
import Stack from 'react-bootstrap/Stack';
import {NavigationBar, Layout} from "./layout"
import * as styles from "./index.module.css"
import ExpandableTable from "./expandableTable"
import Table from "react-bootstrap/Table";
import { Typography } from "@mui/material";
import {isMobile} from "./mobile";

const Location = () => {
  const lmtDriving=[{index: 1, title: "谷歌地圖指引到廬山寺請點擊這裡 ", content: <Typography variant="body1"><u>I-10 西行前往洛杉磯:</u><br/>
  匝道出口25A，Del Mar Ave. 左轉在Del Mar Ave. 上向南行駛大約1.5英里，右轉至Redding Ave. 行駛大約0.2英里，右轉至Mooney Drive.，廬山寺在Mooney Drive和Bailey Avenue交界處右邊。 <br/><br/>
  <u>從I-10 往東East/San Bernardino高速:</u><br/>
  匝道出口Del Mar Ave. 南下行駛大約3英里，
  在Redding Ave.右轉，行駛大約0.4英里，右轉至Mooney Dr.，
  廬山寺在Mooney Drive和Bailey Avenue交界處。 <br/><br/>
  <u>從CA-60西行:</u><br/>
  匝道出口9，San Gabriel Blvd. 行至柔似蜜，用兩條右轉道右轉至San Gabriel Blvd.，直行大約0.6英里，道路會變成Hill Dr. 。當您開過Potrero Grande Blvd.，道路會變成Del Mar Ave.，在下一個路口Miralinda Dr.左轉，道路會變成Mooney Dr.。廬山寺在Mooney Drive和Bailey Avenue交界處右邊。 <br/><br/>
  <u>從CA-60往東:</u><br/>
  匝道出口8，Paramount Blvd.前往Montebello，用兩條左轉道左轉至Paramount Blvd.行駛大約0.7英里左轉至Hill Dr.，行駛大約0.5英里至Del Mar Ave.，開過Potrero Grande Blvd.，大約0.1英里左轉至Miralinda Dr.，繼續行駛到Mooney Drive小右轉。廬山寺在Mooney Drive和Bailey Avenue交界處右邊。 </Typography> }];
  
  const wmtDriving=[{index: 1, title: "谷歌地圖指引到溈山寺請點擊這裡 ", content: <Typography><u>從 I-10 西行前往洛杉磯:</u><br/>
 I-10 往東聖貝納迪諾方向行至柔似蜜，匝道出口25A，Del Mar Ave. ，岔道靠右沿Del Mar Ave.行駛0.3英里，右轉至Emerson Place，行駛0.1英里, 溈山寺在Emerson and Evelyn交界處左邊。 <br/><br/>
  <u>從I-10 往東East/San Bernardino高速:</u><br/>
  I-10 往西洛杉磯方向行至柔似蜜，匝道出口25A，Del Mar Ave. ，左轉至Del Mar Ave.行駛0.5英里，右轉至Emerson Place，行駛0.1 英里，溈山寺在Emerson and Evelyn交界處左邊。 <br/><br/>
  <u>從CA-60西行/洛杉磯:</u><br/>
  高速標誌Pomona/CA-60E/Pomona Fwy，匝道出口8，Paramount Blvd前往Montebello，用兩條左轉道左轉至Paramount Blvd.，行駛0.7英里，左轉至Hill Dr.，Hill Dr.會變成Del Mar Avenue，行駛1.8英里，左轉至Emerson Place，行駛0.1英里，溈山寺在Emerson and Evelyn交界處左邊。 <br/><br/>
  <u>從CA-60往東/波莫納:</u><br/>
  從CA-60西前往洛杉磯，匝道出口9，San Gabriel Blvd. 行至柔似蜜，用兩條右轉道右轉至San Gabriel Blvd.，San Gabriel會變成Del Mar Ave.，行駛2.4英里至Emerson Place，行駛0.1英里，溈山寺在Emerson and Evelyn交界處左邊。 <br/><br/>
  <u>公交 70 & 770路</u><br/>
  在Garvey / Del Mar下車。 </Typography> }];

const jmtDirection=[{index: 1, title: "寶山寺導航", content: <><Typography variant="body1">□ 搭乘火車時:<br/><br/>
    在 KTX 烏松站 (오송역) 下車 → 搭乘市內巴士，在 塔淵三岔路口 (탑연삼거리) 或 韓光公寓 (한빛아파트) 下車後步行抵達。<br/><br/>
    在 京釜線 (경부선) 鳥致院站 (조치원역) 下車 → 朝 清州市 (청주시) 方向行駛約 8 公里，到達 美湖三岔路口 (미호삼거리) 後右轉 → 繼續行駛約 1 公里，到 教員大學 (교원대학교) 後門左轉 (無號誌左轉) → 教員大學後門公車站 就在旁邊。<br/><br/>
□ 使用京釜高速公路時:<br/>
在 清州交流道 (청주IC) 出口往 鳥致院/世宗 (조치원/세종) 方向 → 行駛約 1.5 公里，到達 塔淵三岔路口 (탑연삼거리/미호삼거리) → 左轉後行駛約 1 公里，過了 教員大學後門入口 後，目的地就在右側。<br/><br/>
□ 使用中部高速公路時:<br/>
在 西清州交流道 (서청주IC) 出口後立即右轉 (往 清州站 (청주역) 方向) → 在 清州站前 (청주역전) 左轉 → 在 忠清大學 (충청대학) 前右轉 (往 鳥致院 (조치원) 方向) → 在 美湖三岔路口 (미호삼거리) 左轉後，行駛約 1 公里，過了 教員大學後門入口 後，目的地就在右側。</Typography><br/><img src="/1410_orig.png" /></> }];

let drivingInstructions=  <tr>
    <td colSpan={2}><ExpandableTable rows={lmtDriving}/></td>
    <td colSpan={2}><ExpandableTable rows={wmtDriving}/></td>
  </tr>;

if (isMobile) {
drivingInstructions= <><tr>
    <td colSpan={4}><ExpandableTable rows={lmtDriving}/></td></tr>
    <tr><td colSpan={4}><ExpandableTable rows={wmtDriving}/></td>
  </tr></>;

}
  return (
  <><NavigationBar/>
  {/* Hero Image */}
<div style={{ display: "grid" }}>
  <img
    style={{
      gridArea: "1/1",
      // maxHeight: 600,
    }}
    layout="fullWidth"
    aspectRatio={3 / 1}
    src="/locationBanner.png"/>
  <div
    style={{
      gridArea: "1/1",
      position: "relative",
      placeItems: "center",
      display: "grid",
    }}
  >
  </div>
</div>
{/* Main Content */}
  <Layout>
      <Typography variant="h3">
      <strong>國際菩提光的道場</strong>
      <br/>
      加州</Typography><br/>
      <Typography variant="body1">​廬山寺 7509 Mooney Drive, Rosemead, CA 91770, USA  電話: (626) 280 - 8801&emsp;<a href="https://www.google.com/maps/place/Lu+Mountain+Temple+%2F+Bodhi+Light+International/@34.0514697,-118.1037195,15z/data=!4m6!3m5!1s0x80c2d004d5296e27:0x7e27dd1572a98a79!8m2!3d34.0514941!4d-118.1036418!16s%2Fg%2F11g_q687m">谷歌地圖</a><br/><br/>
      ​溈山寺 ​7732 Emerson Pl, Rosemead, CA 91770, USA  電話: (626) 766-1009&emsp;<a href="https://goo.gl/maps/tdhu3e3Cijv">谷歌地圖</a><br/><br/>
      金林禪院 796 Delmas Ave, San Jose, CA 95125 电话: ​ ​(408) 971-1977&emsp;<a href="https://goo.gl/maps/4KaeUfcgm6E9CXJZ8">谷歌地圖</a><br/><br/>
      法藏寺 3201 Ulloa St, San Francisco, CA 94116 ​電話: (628) 280-2720&emsp;<a href="https://www.google.com/maps/place/Dharma+Treasury+Temple/@37.740395,-122.4929321,17z/data=!3m1!4b1!4m5!3m4!1s0x808f7dd1b2bf72bf:0x9fc371f69403daf1!8m2!3d37.7403908!4d-122.4907434">谷歌地圖</a><br/></Typography><br/>

<Table style={{tableLayout: "fixed"}}><tbody>
  <tr>
    <td><img src="/lmt.jpg" width="183" /></td>
    <td><img src="/lmt2.jpg" width="183" /></td>
    <td><img src="/wmt.jpg" width="183" /></td>
    <td><img src="/wmt2.jpg" width="183" /></td>
  </tr>
{drivingInstructions}
  <tr>
    <td><img src="/gf.jpg" width="183"/></td>
    <td><img src="/gf1.jpg" width="183" /></td>
    <td><img src="/dtt.png" width="183"/></td>
    <td><img src="/dtt1.jpg" width="183"/></td>
  </tr>
</tbody></Table>
<Typography variant="h3">韓國</Typography><br/>
<Typography variant="body1">Jeweled Mountain Temple 寶山寺 보산사 377 Taesungtopyeon-Ro, Gangnae-myeon, Hungduck-gu, Cheongju-si, Chungcheongbuk-do (postal code: 28172) South Korea. 청주시 흥덕구 강내면 태성탑연로 377 Tel: 82-70-8860-3770<br/>
Jeweled Conch Seon Center 寶螺禪院 보라선원 Bảo Loa Thiền Tự, Green Plaza 5th floor, 20, Baekhyeon-ro 101 beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, South Korea, Postal Code: 1359, Tel: 82-31-714-5171</Typography><br/><br/>

<Table style={{tableLayout: "fixed"}}><tbody>
  <tr>
    <td><img src="/korea1.jpg" width="254" /></td>
    <td><img src="/korea2.jpg" width="254" /></td>
    <td><img src="/korea3.jpg" width="254" /></td>
  </tr>
  <tr>
    <td colSpan={3}><ExpandableTable rows={jmtDirection}/></td>
  </tr>
</tbody></Table>
</Layout>
</>
)
  }

export default Location;
